import type { NavLink, NavSection, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Lumawall',
    tagline: 'Wallpapers worth staring at.',
    description: "Free, hand-picked wallpapers for your desktop and phone. Browse mountains, oceans, deserts, cities and abstract art, then download in one click.",
    url: getOrigin()
}

export const mainNav: Array<NavLink> = [
    { label: 'Browse', href: '/wallpapers' },
    { label: 'Categories', href: '/categories' },
    { label: 'Desktop', href: '/wallpapers?device=desktop' },
    { label: 'Phone', href: '/wallpapers?device=phone' }
]

export const footerNav: Array<NavSection> = [
    {
        title: 'Browse',
        links: [
            { label: 'Latest wallpapers', href: '/wallpapers' },
            { label: 'Most downloaded', href: '/wallpapers?sort=popular' },
            { label: 'All categories', href: '/categories' }
        ]
    },
    {
        title: 'Devices',
        links: [
            { label: 'Desktop wallpapers', href: '/wallpapers?device=desktop' },
            { label: 'Phone wallpapers', href: '/wallpapers?device=phone' }
        ]
    }
]

export const WALLPAPERS_PER_PAGE = 24

export const REVALIDATE_SECONDS = 60
